import React from 'lib/react';
import { EVGrid, makeStyles } from 'lib/components';
import Typography from 'commonComponents/typography';
import PropTypes from 'prop-types';
import DashedLine from './DashedLine.component';
import SolidLine from './SolidLine.component';

const getLegendIcon = (type, color) => {
  switch (type) {
    case 'dashedLine':
      return <DashedLine color={color} />;
    case 'solidLine':
      return <SolidLine color={color} />;
    default:
      return <div style={{ width: 16, height: 16, backgroundColor: color }} />;
  }
};

const useStyles = makeStyles((theme) => ({
  legendContainer: {
    width: '100%',
    alignSelf: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    borderRadius: '4px',
    flexDirection: 'column',
    padding: '8px',
    '@media (min-width: 640px)': {
      padding: '0px 8px',
      flexDirection: 'row',
      height: '32px',
      alignItems: 'center',
      gap: '16px',
    },
  },
  legendItem: {
    display: 'flex',
    gap: '4px',
    padding: '8px',
    width: '100%',
    alignItems: 'center',
    '& p': { textTransform: 'uppercase' },
    '&:nth-of-type(odd)': {
      backgroundColor: theme.evPalette.charcoal[100],
    },
    '@media (min-width: 640px)': {
      padding: '0px',
      backgroundColor: 'transparent !important',
      width: 'unset',
    },
  },
  legendLabel: {
    whiteSpace: 'nowrap',
  },
}));

function BarChartLegend(props) {
  const classes = useStyles();
  const { lengendData } = props;

  return (
    <EVGrid className={classes.legendContainer}>
      {lengendData.map(({ label, color, type = 'bar' }) => (
        <EVGrid key={label} className={classes.legendItem}>
          {getLegendIcon(type, color)}
          <Typography variant="label-600" fontColor="charcoal-700" className={classes.legendLabel}>{label}</Typography>
        </EVGrid>
      ))}
    </EVGrid>
  );
}

BarChartLegend.propTypes = {
  lengendData: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    color: PropTypes.string,
    type: PropTypes.oneOf(['bar', 'line', 'dashedLine']),
  })).isRequired,
};

export default BarChartLegend;
